export enum RegexEnum {
  EMPTY_OR_WHITESPACE = "^(?!\\s*$).+",
  TEST_NAME_PATTERN = "(^$|^[/a-zA-Z0-9 '-/().,]{1,50}$)",
  TEST_FOREIGN_CODE_PATTERN = "(^$|^[/a-zA-Z0-9 '-/().,_]{1,32}$)",
  TEST_FOREIGN_SYSTEM_CODE_PATTERN = "^[/a-zA-Z0-9 '-/().,_]{1,100}$",
  TEST_DATE_NAME_PATTERN = "(^$|^[a-zA-Z0-9 '-/;.:\",]{1,100}$)",
  ABBREV_SEASON_CD_PATTERN = "(^$|^[a-zA-Z0-9 -]{1,10}$)",
  ONLY_NUMBER = "^[0-9]*$",
  NUMBER_OR_COMMA = "^[0-9,]*$",
  PARAGRAPH_TX_PATTERN = "^[/a-zA-Z0-9 '-/()<>.,;:\"&%_@=/\n]{1,4000}$",
  PARAGRAPH_DS_PATTERN = "(^$|^[/a-zA-Z0-9 '-/()<>.,=/]{1,100}$)",
  PARAGRAPH_NM_PATTERN = "^[/a-zA-Z0-9 '-/()<>.,=/]{1,50}$",
  NOT_EMPTY_OR_WHITESPACE = "^(?!s*$).+",
  ALPHANUM_SP_50_PATTERN = "(^$|^[/a-zA-Z0-9 '-/()&.,_]{1,50}$)",
  ALPHANUM_SP_100_PATTERN = "(^$|^[/a-zA-Z0-9 ='-.,/()_]{1,100}$)",
  ALPHANUM_SP_4000_PATTERN = "(^$|^[/a-zA-Z0-9 '-/().,_]{1,4000}$)",
  ALPHANUM_SP_100_ACCOMM_PATTERN = "(^$|^[/a-zA-Z0-9 ='-.,/()<>!&]{1,100}$)",
  ALPHANUM_SP_4000_ACCOMM_PATTERN = "(^$|^[/a-zA-Z0-9 '-/()<>!&.,_]{1,4000}$)",
  PRG_NM_PATTERN = "^[a-zA-Z0-9,_]*$"
}



// WEBPACK FOOTER //
// ./client/views/regex.enum.ts